import React from "react";
import { Container, Col, Button } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";

const DownloadReport = ()=>{
    return(
        <>
            <div style={{backgroundImage:'url(./assests/images/downloadReport.svg)',
                backgroundSize:'cover',
                backgroundPosition:"center center",
                height:'565px' 
            }} className="d-md-block d-none">

                <Container className="pt-5 pb-5">
                    <Col md={4}>
                        <h2 className="fs-48">2024 Corporate Gifting Report</h2>
                        <p className="m-0 fs-16 pt-4">
                            Stay updated with eYantra’s Corporate Gifting Report, which lists key gifting solutions, employee appreciation days, and other important observances throughout the year. 
                        </p>

                        <Link to="/contact-us" className="text-decoration-none">
                            <Button id="btnCTA" className="fw-normal mt-4 d-flex align-items-center fs-16">
                            <Icon icon="mynaui:download" width="24" height="24" className="me-1" />
                                  Download Report
                            </Button>
                        </Link>
                       
                        {/* <button id="btnCTA" className="fw-normal mt-4 d-flex align-items-center fs-16">
                        <Icon icon="mynaui:download" width="24" height="24" className="me-1" />
                        Download Report
                        </button> */}
                    </Col>
                    <p>
                            
                        </p>
                </Container>


            </div>
            {/**Mobile  */}
            <div style={{
                backgroundImage:'linear-gradient(0deg, rgba(26, 26, 26, 0.58), rgba(26, 26, 26, 0.58)), url(./assests/images/report.jpg)',
                backgroundSize:'cover',
                backgroundPosition:"center center",
            }} className="d-md-none d-block">

                <Container className="pt-4 pb-5">
                    <Col md={4}>
                        <h2 className="fs-38 text-white">2024 Corporate Gifting Report</h2>
                        <p className="m-0 fs-16 pt-3 text-white">
                            Stay updated with eYantra’s Corporate Gifting Report, which lists key gifting solutions, employee appreciation days, and other important observances throughout the year. 
                        </p>

                        <Link to="/contact-us" className="text-decoration-none">
                            <Button id="btnCTA" className="fw-normal mt-4 d-flex align-items-center fs-16">
                            <Icon icon="mynaui:download" width="24" height="24" className="me-1" />
                                  Download Report
                            </Button>
                        </Link>
                    </Col>
                    <p>
                            
                        </p>
                </Container>


            </div>
        </>
    )
}

export default DownloadReport;